import { MenuItem } from "@mui/material";
import React from "react";
import { translate } from "../../../../common/providers";
import styles from "../MenuItem.module.css";
import { icon, IconComponent } from "../../../../common/components";

const MenuItemSelectable = React.forwardRef(
	(
		{
			autoTranslate = "yes",
			children,
			className,
			disabled = false,
			iconClassname = null,
			iconName = null,
			iconColor = null,
			menuItem,
			onIsSelected = null,
			onSelect,
		},
		ref
	) => {
		const isSelected = onIsSelected && onIsSelected(menuItem.to || menuItem?.name);
		const handleSelect = () => {
			if (!isSelected) {
				onSelect(menuItem);
			}
		};

		return (
			<MenuItem
				ref={ref}
				aria-label={translate(menuItem?.name)}
				className={`${className} ${styles.menuItem} ${isSelected && styles["menuItem--selected"]}`}
				disabled={disabled}
				disableRipple={isSelected}
				id={translate(menuItem?.name)}
				translate={autoTranslate}
				onClick={handleSelect}
			>
				{children || (
					<>
						{iconName && (
							<IconComponent
								className={`${styles.icon} ${iconClassname}`}
								color={iconColor}
								icon={icon[iconName]}
							/>
						)}
						{translate(menuItem?.name)}
					</>
				)}
			</MenuItem>
		);
	}
);

export default MenuItemSelectable;
